import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import "../../../styles/assets/css/pages/patient_contract.css";
import ReactPlayer from "react-player";

class TutorialList extends Component {

  render() {
    return (
      <div className="patient_contract_list box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">Program Information</div>
        </div>
        <div className="row top_space1">
          <div className="small-12 columns txt_title2">
          <ul>
            <li><a href="/member/tutorial_video/1" target="_blank">Intro to FITT-BD</a></li>
            <li><a href="/member/tutorial_video/2" target="_blank">Intro to FITT-BD Dashboard</a></li>
            <li><a href="/member/tutorial_video/3" target="_blank">Intro to Patient Contract</a></li>
            <li><a href="/pdf/FITT-BD_Patient_Handbook.pdf" target="_blank">FITT-BD Patient Handbook</a></li>
            <li><a href="/pdf/Executive_Functioning_Coaching/FITT-BD_Coaching_Overview.pdf" target="_blank">FITT-BD Coaching Overview</a></li>
          </ul>
          </div>
          <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({ type: "LOAD_USER_AUTH", payload: response });
  },
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TutorialList)
